'use client';
import { CasinoCategory } from '@/backend/casino/get-categories/types';
import { getIcon } from '@/Icons';
import useOpenCloseToggle from '../../../hooks/useOpenCloseToggle';
import ContentWrapper from '../../ContentWrapper/ContentWrapper';
import SectionTitle from '../../SectionTitle/SectionTitle';
import SideNavItem from '../../SideNavItem/SideNavItem';

const language = 'EN';

function CasinoCategoriesClient({
	categories,
}: {
	categories: CasinoCategory[];
}) {
	const { open, toggleOpen } = useOpenCloseToggle();

	return (
		<>
			<SectionTitle title="Casino" toggleOpen={toggleOpen} open={open} />
			<ContentWrapper open={open}>
				{categories?.map((category, index) => (
					<SideNavItem
						key={index}
						title={category.name?.[language]
							?.toLowerCase()
							.split('-')
							.join(' ')}
						link={`/casino/category/${category.name?.[language]?.toLowerCase().split(' ').join('-')}`}
						icon={getIcon(category.iconKey)}
					/>
				))}
				<SideNavItem
					title={'Providers'}
					link={`/providers`}
					icon={getIcon('providers')}
				/>
			</ContentWrapper>
		</>
	);
}

export default CasinoCategoriesClient;
